// src/pages/Login.js
import React, { useContext, useState } from "react";
import { AuthContext } from "../components/AuthContext";
import "./Login.css"; // Arquivo CSS para os estilos
import googleIcon from "../images/google-icon.svg";
import appLogo2 from "../images/app_gestao_ga_logo2.png";
import { ClipLoader } from "react-spinners";

const Login = () => {
  const { loginWithGoogle } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true); // Ativa o loading
    try {
      await loginWithGoogle(); // Chama a função de login com Google
    } catch (error) {
      console.error("Erro no login com Google:", error);
    }
  };
  
  return (
    <div className="login-container">      
      <img src={appLogo2} alt="Gestao GA" className="app-logo-login"/>
      <h2 className="app-title-login">Gestão GA</h2>
        <p>Monitore vários Google Analytics</p>
      
      {isLoading ? (
        <div className="loading-spinner">
          <ClipLoader color="#007bff" size={40} />
          <span>Autenticando...</span>
        </div>
      ) : (   
      
      <button className="google-login-button" onClick={handleLogin}>
        <img src={googleIcon} alt="Google" className="google-icon" />
        Continuar com o Google
      </button>
    )} 
    </div>
  );
};

export default Login;
